import { ChangeDetectionStrategy, Component } from '@angular/core';

import { LotIconEnum } from '../../../graphql/service/graphql-auto-main-service';

@Component({
  selector: 'app-auto-lot-guide-icons',
  templateUrl: './auto-lot-guide-icons.component.html',
  styleUrls: ['./auto-lot-guide-icons.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AutoLotGuideIconsComponent {
  readonly guideIcons = Object.values(LotIconEnum);
}
